import API from '../utils/api';

const api = new API({
  url: process.env.REACT_APP_URLAPI
});

export default api;
